import { IRequestParams, IResponse } from '@dash/apiInstance';
import { all, call, put, takeEvery } from 'redux-saga/effects';
import { sendRequest } from 'src/helpers/saga';
import { executeAction } from '../../../../../../../../helpers/api';
import { logger } from '../../../../../../../../helpers/logger';
import { t } from '../../../../../../../../i18n';
import notifications from '../../../../../../../../redux/notifications/actions';
import actionTypes from './actionTypes';
import { ProcessActionRequestAction } from './actions.d';
import { IProcessActionResponse } from './types.d';
import cardsActionTypes from '../../../tabs/cards/actionTypes';

function* processAction({ payload }: ProcessActionRequestAction<{}, {}>) {
  try {
    const { url, method, data, type, id, key, cardAddingStrategy } = payload;

    const result: IResponse<IProcessActionResponse> = yield call<any, IRequestParams<{}, {}>, string>(
      sendRequest,
      executeAction,
      { url, method, data },
      notifications.REQUEST_ERROR,
    );

    if (result?.messages || result?.success) {
      if (key === 'delete_action' || method?.toLowerCase() === 'delete') {
        yield put({
          type: cardsActionTypes.LOAD_CARDS_REQUEST,
          payload: { type, id, cardAddingStrategy, pageSize: 9999 },
        });

        yield put(
          notifications.addNotification({
            headline: t('dash.common.notification.success_headline'),
            type: 'success',
            message: t('dash.common.notification.created_successfully', {
              item: t('dash.clients.subUnit.card_label'),
            }),
          }),
        );
      } else {
        yield put(
          notifications.addNotification({
            headline: t('dash.common.notification.success_headline'),
            type: 'success',
            message: result?.messages?.join(' ') || '',
          }),
        );
      }

      yield put({ type: actionTypes.PROCESS_ACTION_SUCCESS });
    } else {
      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.error_headline'),
          type: 'error',
          message: t('dash.common.notification.something_went_wrong'),
        }),
      );

      yield put({ type: actionTypes.PROCESS_ACTION_ERROR });
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actionTypes.PROCESS_ACTION_REQUEST, processAction)]);
}
